import React from "react";
import PropTypes from "prop-types";

import { reachGoal } from "../utils";

function Intro(props) {
  const { onStart } = props;
  return (
    <>
      <h1 className="intro__title">Попробуйте оценить стоимость криптоарта!</h1>
      <p className="intro__text">
        Сможете ли вы угадать реальную стоимость цифрового искусства? Попробуйте
        свои силы в тесте, который мы сделали вместе с форумом по информационной
        безопасности{" "}
        <a
          onClick={() => {
            reachGoal("phd_1");
            return true;
          }}
          href="https://phdays.com/ru/?utm_source=afisha-landing&utm_medium=link&utm_campaign=phd-11-nft"
          target="_blank"
        >
          Positive Hack Days
        </a>
        , который пройдет 18-19 мая. На одном из его{" "}
        <a
          onClick={() => {
            reachGoal("conkurs");
            return true;
          }}
          href="https://phdays.com/ru/program/contests/something-something-blockchain/?utm_source=afisha-landing&utm_medium=link&utm_campaign=phd-11-nft"
          target="_blank"
        >
          конкурсов
        </a>{" "}
        белые хакеры испытают безопасность криптоарта, а мы вместе с{" "}
        <a
          onClick={() => {
            reachGoal("reutov");
            return true;
          }}
          href="https://twitter.com/theRaz0r"
          target="_blank"
        >
          Арсением Реутовым
        </a>
        , руководителем отдела исследований безопасности приложений Positive
        Technologies, прямо сейчас расскажем, как не попасться на уловки
        киберпреступников.
      </p>

      <button
        className="button intro__button"
        type={"button"}
        onClick={onStart}
      >
        Начать
      </button>
    </>
  );
}

Intro.propTypes = { onStart: PropTypes.func.isRequired };

export default Intro;
